import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations as TracingIntegrations } from '@sentry/tracing';
import { ChakraProvider } from '@chakra-ui/react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import theme from './styles/theme';
import './styles/main.scss';

import App from './app/view';

library.add(fab);
library.add(fas);
library.add(far);

require('dotenv').config();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [ new TracingIntegrations.BrowserTracing() ],
  tracesSampleRate: 0.25,
  environment: process.env.NODE_ENV,
});

ReactDOM.render(
  <ChakraProvider theme={theme}>
    <App />
  </ChakraProvider>,
  document.getElementById('root'),
);
